import {Component, OnInit} from '@angular/core';
import {SuppliersService} from '../../../services/suppliers.service';
import {Observable, tap} from 'rxjs';
import {Router} from '@angular/router';
import {ProleisObject} from "@proleis/proleis-rest-client";

@Component({
  selector: 'ps-contacts-list',
  templateUrl: 'contacts.list.component.html'
})
export class ContactsListComponent implements OnInit {

  suppliers$: Observable<ProleisObject[]>;

  constructor(public suppliersService: SuppliersService, private router: Router) {
  }

  ngOnInit() {
    this.suppliers$ = this.suppliersService.getSuppliers().pipe(
      tap(result => {
        if (result.length === 1) {
          this.router.navigate(['/suppliers/' + result[0].OBJECT_ID]);
        }
      })
    );
  }
}
